import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Popup } from 'nicetoolfn';
import { rootStore, MobxContext } from "@/store";

import App from '@/views/app';

window.$refPopup = React.createRef();
ReactDOM.render(<MobxContext.Provider value={rootStore}>
    <App/>
    <Popup ref={$refPopup}/>
  </MobxContext.Provider>,
  document.getElementById('root')
);
